import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brand_Logo } from '../../global/assets/Icons';
import AtomicButton from '../../atomic/button/AtomicButton';

/* ── Logo with a text fallback, so the header never shows a broken image ── */
function BrandLogo({ height = 36 }) {
  const [failed, setFailed] = useState(!Brand_Logo); // missing import → fall back right away

  if (process.env.NODE_ENV !== 'production' && typeof Brand_Logo !== 'string') {
    console.warn('Brand_Logo is not an image URL:', Brand_Logo);
  }

  if (failed) {
    return (
      <span
        style={{
          fontFamily: "'DM Serif Display', Georgia, serif",
          fontSize: `${Math.round(height * 0.7)}px`,
          lineHeight: 1,
          color: '#fff',
          whiteSpace: 'nowrap',
        }}
      >
        Single<span style={{ color: '#FF7A28' }}>Combo</span>
      </span>
    );
  }

  return (
    <img
      src={Brand_Logo}
      alt='SingleCombo'
      height={height}
      decoding='async'
      fetchpriority='high'
      onError={() => setFailed(true)}
      style={{ height: `${height}px`, width: 'auto', display: 'block' }}
    />
  );
}

function ComingSoonHeader() {
  const navigate = useNavigate();

  const RedirectHome = async () => {
    navigate('/');
    window.location.reload();
  };

  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        height: '65px',
        padding: '0 5vw',
        background: '#070425ff',
        // background:
        //   'radial-gradient(900px 600px at 50% 35%, rgba(255,255,255,0.04) 0%, rgba(24,20,54,1) 50%), linear-gradient(180deg, #181436 0%, #090716 100%)',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <button
        type='button'
        onClick={RedirectHome}
        aria-label='SingleCombo home'
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          height: '100%',
          padding: 0,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          minWidth: 0,
        }}
      >
        {/* <span
          aria-hidden='true'
          style={{
            flexShrink: 0,
            width: '5px',
            height: '30px',
            borderRadius: '5px',
            background: '#FF7A28',
          }}
        /> */}
        <BrandLogo height={40} />
      </button>

      <AtomicButton
        label='We’re Hiring'
        handleSubmit={() => navigate('/career')}
        style={{
          width: '140px',
          height: '40px',
          flexShrink: 0,
          fontSize: '16px',
          // backgroundColor: 'rgb(255, 122, 40)',
          background: '#070425ff',
          border: '1px solid rgb(255, 122, 40)',
          color: 'rgba(251, 247, 245, 1)',
        }}
        loading={false}
        disabled={false}
      />
    </header>
  );
}

export default ComingSoonHeader;
